import { genericCRUDService } from '../../helpers/api';

export const SERVICE_URI = '/taxonomies';
export const BASE_URI = '/api/v1/token/subtypes';

export const { findAll, findOne, create, update, remove } = genericCRUDService(
  SERVICE_URI,
  BASE_URI,
);
